export type SupplierOrderBy = 'CREATION_DATE' | 'TITLE';
export type SupplierOrderDir = 'ASC' | 'DESC';

export interface SupplierFilters {
  supplierTitle: string;
  createdOnFrom: string | null;
  createdOnTo: string | null;
  orderBy: SupplierOrderBy;
  orderDir: SupplierOrderDir;
}

export const DEFAULT_SUPPLIER_FILTERS: SupplierFilters = {
  supplierTitle: '',
  createdOnFrom: null,
  createdOnTo: null,
  orderBy: 'CREATION_DATE',
  orderDir: 'ASC',
};
